import React, { useRef, useState } from "react";
import curveLine from "../assets/curveLine.png";
import eclipse from "../assets/Elipse.png";
import { FaAngleDown, FaAngleUp, FaArrowUpLong } from "react-icons/fa6";

const Faqs = () => {
  const faqs = [
    {
      ques: "What makes My Wali different from other marriage apps?",
      ans: "B Club focuses on Cybersecurity, Real Estate, and Food & Beverage. Our investments are aimed at fostering growth and innovation in these key areas.",
    },
    {
      ques: " How does guardian verification work?",
      ans: "B Club focuses on Cybersecurity, Real Estate, and Food & Beverage. Our investments are aimed at fostering growth and innovation in these key areas.",
    },
    {
      ques: "Is my information secure on My Wali?",
      ans: "B Club focuses on Cybersecurity, Real Estate, and Food & Beverage. Our investments are aimed at fostering growth and innovation in these key areas.",
    },
    {
      ques: "Can I browse profiles without creating a profile?",
      ans: "B Club focuses on Cybersecurity, Real Estate, and Food & Beverage. Our investments are aimed at fostering growth and innovation in these key areas.",
    },
  ];
  const [openIndex, setOpenIndex] = useState(null); // Track which accordion is open

  const contentRefs = useRef([]); // To store refs for each accordion

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index); // Toggle the specific accordion
  };
  return (
    <div id="faqs" className="bg-gray-1000 py-16 relative">
      <img
        className="w-full opacity-50 absolute top-[50%] "
        src={eclipse}
        alt=""
      />
      <h2 className="flex flex-col items-center gap-5 text-center text-4xl sm:text-5xl  text-themeColor mb-8 font-yeseva pb-5">
        FAQ’s
        <h1 className="font-yeseva text-3xl leading-none text-slate-950  sm:text-4xl">
          <span>What You Need to </span>
          <span className="text-secondColor">Know?</span>
        </h1>
        <div>
          <img src={curveLine} alt="" />
        </div>
      </h2>
      <div className="w-full relative">
        <div
          data-aos="fade-up"
          className="w-full md:w-1/2 mx-auto flex flex-col justify-center gap-3 px-5"
        >
          {faqs.map((items, index) => (
            <div key={index}>
              <div
                className={`  text-white flex px-5 text-lg py-3 rounded justify- items-center cursor-pointer ${
                  openIndex === index ? "faqs" : "faqs"
                }`}
                onClick={() => toggleAccordion(index)}
              >
                <div className="w-[90%]">{items.ques}</div>
                <div className="w-[10%] flex items-center justify-center m-left-auto mr-0">
                  {openIndex === index ? <FaAngleUp /> : <FaAngleDown />}
                </div>
              </div>
              <div
                ref={(el) => (contentRefs.current[index] = el)} // Assign ref for each content
                className={`transition-max-height duration-500 ease-in-out overflow-hidden ${
                  openIndex === index ? "max-h-screen" : "max-h-0"
                }`}
                style={{
                  maxHeight:
                    openIndex === index
                      ? `${contentRefs.current[index]?.scrollHeight}px`
                      : "0px",
                }}
              >
                <div className="px-5 py-10 text-white gradientPurple rounded shadow mt-1">
                  {items.ans}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Faqs;
